import { render, staticRenderFns } from "./MaterialDetail.vue?vue&type=template&id=34a78253&scoped=true"
import script from "./MaterialDetail.vue?vue&type=script&lang=ts"
export * from "./MaterialDetail.vue?vue&type=script&lang=ts"
import style0 from "./MaterialDetail.vue?vue&type=style&index=0&id=34a78253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a78253",
  null
  
)

export default component.exports